<!-- user-modal.component.html -->
<h2 mat-dialog-title>
  @switch (this.data.formType) { @case (this.addEditConstants.ADD_FORM_TYPE) {
  Add User } @case (this.addEditConstants.EDIT_FORM_TYPE) { Edit User } @default
  { View User } }
  <button mat-icon-button mat-dialog-close class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<!-- <pre>Form values: {{injectorIDs.value | json}}</pre> -->
<mat-dialog-content class="add-edit-content">
  <mat-stepper #stepper [linear]="true">
    <mat-step
      [stepControl]="userInfoFormGroup"
      errorMessage="User Information Form Incomplete."
    >
      <form [formGroup]="userInfoFormGroup">
        <ng-template matStepLabel>User Information</ng-template>
        <mat-form-field>
          <mat-label>{{ ReadableDisplay.userAssignedRole }}</mat-label>
          <mat-select formControlName="userAssignedRole">
            @for(userAssignedRole of userAssignedRoles; track $index){
            <mat-option [value]="userAssignedRole">{{
              userRoleEnumForTemplate[userAssignedRole]
            }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>{{ ReadableDisplay.userName }}</mat-label>
          <input
            matInput
            Trim
            noSpecialCharacters
            formControlName="userName"
            placeholder="{{ ReadableDisplay.userName }}"
            maxlength="6"
          />
          @if
          (userInfoFormGroup.get(addEditConstants.USERNAME_CONTROL)?.hasError(addEditConstants.FORM_VALIDATION_ERROR_REQUIRED)
          ){
          <mat-error> {{ ReadableDisplay.userName }} is required </mat-error>
          }
          @if
          (userInfoFormGroup.get('userName')?.hasError("minlength") || userInfoFormGroup.get('userName')?.hasError("maxlength"))
          {
          <mat-error>
            {{ReadableDisplay.userName}} must be between 4 and 6
          </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>{{ ReadableDisplay.userFirstName }}</mat-label>
          <input
            matInput
            Trim
            formControlName="userFirstName"
            placeholder="{{ ReadableDisplay.userFirstName }}"
            [maxlength]="addEditConstants.FREE_TEXT_MAX_LENGTH"
          />
          @if
          (userInfoFormGroup.get('userFirstName')?.hasError(addEditConstants.FORM_VALIDATION_ERROR_REQUIRED))
          {
          <mat-error>
            {{ ReadableDisplay.userFirstName }} is required
          </mat-error>
          }@else if (userInfoFormGroup.get('userFirstName')?.hasError('tooManySpecialCharsInARow')) {
            <mat-error>
              No more than 3 special characters in succession are allowed.
            </mat-error>
          }@else if (userInfoFormGroup.get('userFirstName')?.hasError('onlySpecialChars')) {
            <mat-error>
              Input cannot be made up of only special characters.
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>{{ ReadableDisplay.userMiddleName }}</mat-label>
          <input
            matInput
            Trim
            [maxlength]="addEditConstants.FREE_TEXT_MAX_LENGTH"
            formControlName="userMiddleName"
            placeholder="{{ ReadableDisplay.userMiddleName }}"
          />
          @if (userInfoFormGroup.get('userMiddleName')?.hasError('tooManySpecialCharsInARow')) {
            <mat-error>
              No more than 3 special characters in succession are allowed.
            </mat-error>
          }@else if (userInfoFormGroup.get('userMiddleName')?.hasError('onlySpecialChars')) {
            <mat-error>
              Input cannot be made up of only special characters.
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>{{ ReadableDisplay.userLastName }}</mat-label>
          <input
            matInput
            Trim
            [maxlength]="addEditConstants.FREE_TEXT_MAX_LENGTH"
            formControlName="userLastName"
            placeholder="{{ ReadableDisplay.userLastName }}"
          />
          @if
          (userInfoFormGroup.get('userLastName')?.hasError(addEditConstants.FORM_VALIDATION_ERROR_REQUIRED))
          {
          <mat-error>
            {{ ReadableDisplay.userLastName }} is required
          </mat-error>
          }@else if (userInfoFormGroup.get('userLastName')?.hasError('tooManySpecialCharsInARow')) {
            <mat-error>
              No more than 3 special characters in succession are allowed.
            </mat-error>
          }@else if (userInfoFormGroup.get('userLastName')?.hasError('onlySpecialChars')) {
            <mat-error>
              Input cannot be made up of only special characters.
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>{{ ReadableDisplay.userEmailId }}</mat-label>
          <input
            matInput
            Trim
            [maxlength]="addEditConstants.FREE_TEXT_MAX_LENGTH"
            formControlName="userEmailId"
            placeholder="Email"
            type="email"
          />
          <mat-hint>Please enter a business email address.</mat-hint>

          @if
          (userInfoFormGroup.get(addEditConstants.EMAIL_ID_CONTROL)?.hasError(addEditConstants.FORM_VALIDATION_ERROR_REQUIRED))
          {
          <mat-error> {{ ReadableDisplay.userEmailId }} is required </mat-error>
          } @if (userInfoFormGroup.get(addEditConstants.EMAIL_ID_CONTROL)?.hasError('strictEmail')) {
          <mat-error>
            {{ ReadableDisplay.userEmailId }} format is required
          </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>{{ ReadableDisplay.userOrganizationName }}</mat-label>
          <input
            matInput
            Trim
            [maxlength]="addEditConstants.FREE_TEXT_MAX_LENGTH"
            formControlName="userOrganizationName"
            placeholder="{{ ReadableDisplay.userOrganizationName }}"
          />
          @if
          (userInfoFormGroup.get('userOrganizationName')?.hasError(addEditConstants.FORM_VALIDATION_ERROR_REQUIRED))
          {
          <mat-error>
            {{ ReadableDisplay.userOrganizationName }} is required
          </mat-error>
          }@else if (userInfoFormGroup.get('userOrganizationName')?.hasError('tooManySpecialCharsInARow')) {
            <mat-error>
              No more than 3 special characters in succession are allowed.
            </mat-error>
          }@else if (userInfoFormGroup.get('userOrganizationName')?.hasError('onlySpecialChars')) {
            <mat-error>
              Input cannot be made up of only special characters.
            </mat-error>
          }
        </mat-form-field>
        @if(userInfoFormGroup.get(this.addEditConstants.ASSIGNED_ROLE_CONTROL)?.value
        ===this.addEditConstants.USER_TYPE_ENUM_KEYS.FSE) {<mat-form-field
          appearance="fill"
        >
          <mat-label>{{ ReadableDisplay.userRegion }}</mat-label>
          <mat-select
            placeholder="{{ ReadableDisplay.userRegion }}"
            formControlName="userRegion"
            multiple
          >
            @for(region of regionsArray; track $index){
            <mat-option [value]="region">{{ region }}</mat-option>
            }
          </mat-select>
          @if
          (userInfoFormGroup.get(addEditConstants.REGION_CONTROL)?.hasError(addEditConstants.FORM_VALIDATION_ERROR_REQUIRED))
          {
          <mat-error> {{ ReadableDisplay.userRegion }} is required </mat-error>
          } </mat-form-field
        >}
        @if(userInfoFormGroup.get(this.addEditConstants.ASSIGNED_ROLE_CONTROL)?.value
        === this.addEditConstants.USER_TYPE_ENUM_KEYS.FSE ||
        userInfoFormGroup.get(this.addEditConstants.ASSIGNED_ROLE_CONTROL)?.value
        === this.addEditConstants.USER_TYPE_ENUM_KEYS.DEALER){
        <mat-form-field appearance="fill">
          <mat-label> {{ ReadableDisplay.userCountry }} </mat-label>
          <mat-select
            placeholder="{{ ReadableDisplay.userCountry }}"
            formControlName="userCountry"
            multiple
          >
            <mat-option value="ALL">ALL</mat-option>

            @for (country of countriesArray; track $index) {
            <mat-option [value]="country" [disabled]="isAllCountriesSelected">{{
              country
            }}</mat-option>
            }
          </mat-select>
          @if
          (userInfoFormGroup.get('userCountry')?.hasError(addEditConstants.FORM_VALIDATION_ERROR_REQUIRED))
          {
          <mat-error> {{ ReadableDisplay.userCountry }} is required </mat-error>
          }
        </mat-form-field>
        }
        <div id="active-toggle">
          <label>{{ ReadableDisplay.userIsActive }}:</label>
          <mat-slide-toggle formControlName="userIsActive"></mat-slide-toggle>
          @if
          (userInfoFormGroup.get('userIsActive')?.hasError(addEditConstants.FORM_VALIDATION_ERROR_REQUIRED))
          {
          <mat-error>
            {{ ReadableDisplay.userIsActive }} is required
          </mat-error>
          }
        </div>
      </form>
      <mat-dialog-actions>
        <button
          mat-button
          matStepperNext
          [disabled]="userInfoFormGroup.invalid"
        >
          Next
        </button>
      </mat-dialog-actions>
    </mat-step>
    <mat-step
      [stepControl]="userProductInfoFormGroup"
      errorMessage="Product Information Form Incomplete."
    >
      <form [formGroup]="userProductInfoFormGroup">
        <ng-template matStepLabel>Product Information</ng-template>
        <!-- @if(userrmationFormGroup.get(this.addEditConstants.ASSIGNED_ROLE_CONTROL)?.value
        === this.addEditConstants.USER_TYPE_ENUM_KEYS.BIOMED){ -->
        <!--Each injector has a row of values-->
        <div formArrayName="userProductInjectorIDs">
          @for(injector of injectorIDs.controls; track injector; let i =
          $index){
          <div [formGroupName]="i" class="product-row">
            <mat-form-field appearance="fill">
              <mat-label>{{ ReadableDisplay.userProductTypes }}</mat-label>
              <mat-select
                placeholder="{{ ReadableDisplay.userProductTypes }}"
                formControlName="injectorType"
              >
                @for(productType of productTypes; track $index){
                <mat-option
                  [disabled]="!availableProductTypes.includes(productType)"
                  [value]="productType"
                  >{{ productTypeObject[productType] }}</mat-option
                >
                }
              </mat-select>
              @if
              (injector.get(this.addEditConstants.INJECTOR_TYPE_CONTROL)?.hasError(addEditConstants.FORM_VALIDATION_ERROR_REQUIRED))
              {
              <mat-error>
                {{ ReadableDisplay.userProductTypes }} is required
              </mat-error>
              }
            </mat-form-field>
          @if(userInfoFormGroup.get(this.addEditConstants.ASSIGNED_ROLE_CONTROL)?.value
        === this.addEditConstants.USER_TYPE_ENUM_KEYS.BIOMED) {
          <mat-form-field appearance="fill" class="injectorIds">
              <mat-label>{{
                ReadableDisplay.userProductInjectorIDs
              }}</mat-label>
              <mat-chip-grid
                #chipGrid
                aria-label="Enter injectorIDs"
                formControlName="injectorID"
              >
                @for (injectorID of
                injector.get(this.addEditConstants.INJECTOR_ID_CONTROL)?.value;
                track $index; let j = $index) {
                <mat-chip-row
                  (removed)="removeId(i, j)"
                  [editable]="true"
                  [aria-description]="'press enter to edit ' + injectorID"
                >
                  {{ injectorID }}
                  <button
                    matChipRemove
                    [attr.aria-label]="'remove ' + injectorID"
                  >
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>
                }

                <input
                  placeholder="Ex:AB017829"
                  [matChipInputFor]="chipGrid"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="true"
                  (matChipInputTokenEnd)="addId(i, $event)"
                />
                <mat-icon matSuffix>add</mat-icon>
              </mat-chip-grid>
              @if
              (injector.get(this.addEditConstants.INJECTOR_ID_CONTROL)?.hasError('arrayNotEmpty'))
              {
              <mat-error> IDs are required </mat-error>
              }
              @if
              (injector.get(this.addEditConstants.INJECTOR_ID_CONTROL)?.hasError('specialCharacters'))
              {
              <mat-error> IDs must be alphanumeric </mat-error>
              }
            </mat-form-field>}
            <mat-form-field appearance="fill">
              <mat-label>License expiration </mat-label>
              <input
                matInput
                Trim
                [matDatepicker]="picker"
                [min]="minDate"
                formControlName="userLicenseExpirationDateTime"
              />
              <mat-hint>MM/DD/YYYY</mat-hint>
              <mat-datepicker-toggle
                matIconSuffix
                [for]="picker"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                @if(injector.get('userLicenseExpirationDateTime')?.hasError('matDatepickerMin')){
                  <mat-error >
                    Date must be in the future
                    </mat-error>
                  }
                  </mat-form-field>
                  @if (injectorIDs.length > 1) {
            <button mat-button (click)="removeProduct(i)">
              Remove Product
            </button>
            }
          </div>
          }
        </div>
        <button
          mat-button
          [disabled]="
            !(availableProductTypes.length > 0) ||
            injectorIDs.value.length >= productTypes.length
          "
          (click)="addProduct(true)"
        >
          Add Injector
        </button>

        <!-- } @else {
        <mat-form-field appearance="fill">
          <mat-label>{{ ReadableDisplay.userProductTypes }}</mat-label>
          <mat-select
            placeholder="{{ ReadableDisplay.userProductTypes }}"
            formControlName="userProductTypes"
            multiple
            (selectionChange)="onProductTypeChange($event.value)"
          >
            @for(productType of productTypes; track $index){
            <mat-option [value]="productType">{{ productType }}</mat-option>
            }
          </mat-select>
          @if
          (userProductInfoFormGroup.get(this.addEditConstants.PRODUCT_TYPE_CONTROL)?.hasError(addEditConstants.FORM_VALIDATION_ERROR_REQUIRED))
          {
          <mat-error>
            {{ ReadableDisplay.userProductTypes }} is required
          </mat-error>
          }
        </mat-form-field>
        } -->
      </form>
      <mat-dialog-actions>
        <button mat-button matStepperPrevious>Back</button>
        <button mat-button [disabled]="isSubmitDisabled" (click)="saveUser()">
          Submit
        </button>
      </mat-dialog-actions>
    </mat-step>
  </mat-stepper>
</mat-dialog-content>
